<ng-container *transloco="let t">
<div class="container px-0 mt-5">
  <div class="row my-2">
    <div class="col-md-6 d-flex align-items-end justify-content-center">
      <div class="form-group w-100">
        <input type="text" class="form-control" [placeholder]="t('portal.loans.search')" (input)="onSearch($event)" />
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label class="form-label" for="loanStatus">{{ t('portal.loans.loanStatus') }}</label>
        <select class="form-select" id="loanStatus" [(ngModel)]="selectedLoanStatus"
          (ngModelChange)="filterByLoanStatus(selectedLoanStatus)">
          <option [ngValue]="null">{{ t('portal.loans.all') }}</option>
          @for (s of loanStatuses; track s.value) {
            <option [ngValue]="s.value">
              {{ s.name }}
            </option>
          }
        </select>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label class="form-label" for="sortField">{{ t('portal.loans.sortBy') }}</label>
        <select class="form-select" id="sortField" [(ngModel)]="selectedSortField"
          (ngModelChange)="sortBySortField(selectedSortField)">
          @for (f of sortFields; track f.value) {
            <option [ngValue]="f.value">
              {{ f.name }}
            </option>
          }
        </select>
      </div>
    </div>
  </div>
</div>

<ng-template #loanCardView>
  <div class="row">
    @for (application of filteredApplications; track application.applicationId) {
      <loan-info
        [portalContent]="portalContent"
        [isDetailView]="false"
        [showViewTasksButton]="true"
        [isAgent]="isAgent"
        [showBorrowerContactDetails]="true"
        [otherBorrowersOnLoan]="otherBorrowersOnLoan.get(application.applicationId)"
        [application]="application">
      </loan-info>
    }
  </div>
</ng-template>

@if (selectDisplayMode === 'card') {
  <div class="">
    <ng-template [ngTemplateOutlet]="loanCardView"></ng-template>
  </div>
}

@if (selectDisplayMode === 'list') {
  <div class="mt-4 container">
    <div class="d-none d-md-block d-lg-block d-xl-block">
      <table class="table bp-table loan-table">
        <thead>
          <tr>
            <th></th>
            <th>{{ t('portal.loans.name') }}</th>
            <th>{{ t('portal.loans.loanAmount') }}</th>
            <th>{{ t('portal.loans.interestRate') }}</th>
            <th>{{ t('portal.loans.loanStatus') }}</th>
            <th>{{ t('portal.loans.address') }}</th>
            <th>{{ t('portal.loans.contact') }}</th>
            <th class="text-end">{{ t('portal.loans.actions') }}</th>
          </tr>
        </thead>
        <tbody>
          @for (app of filteredApplications; track app.applicationId) {
            <tr class="bp-table-row">
              <td>
                <span class="position-relative me-4"><i class="fa fa-check-circle fa-2x"></i>
                  @if (totals[app.applicationId]?.taskCount > 0) {
                    <span
                      class="position-absolute top-1 start-100 translate-middle badge rounded-pill bg-danger">
                      {{ badgeLabel(totals[app.applicationId]?.taskCount) }}
                    </span>
                  }
                </span>

                <span class="position-relative"><i class="fa fa-comment fa-2x"></i>
                  @if (totals[app.applicationId]?.messageCount > 0) {
                    <span
                      class="position-absolute top-1 start-100 translate-middle badge rounded-pill bg-danger">
                      {{ badgeLabel(totals[app.applicationId]?.messageCount) }}
                    </span>
                  }
                </span>
              </td>
              <td>
                {{ app.applicationName }}
              </td>
              <td>
                @if (!app.loanAmountHiddenOnPortals) {
                  <span>{{
                    app.loanAmount || 0 | currency
                  }}</span>
                }
                @if (app.loanAmountHiddenOnPortals) {
                  <span>-</span>
                }
              </td>
              <td>
                @if (!app.interestRateHiddenOnPortals) {
                  <span>
                    {{ app.interestRate || 0 }} %</span>
                }
                @if (app.interestRateHiddenOnPortals) {
                  <span>-</span>
                }
              </td>
              <td [ngbPopover]="app.blurb" [disablePopover]="!app.blurb" triggers="mouseenter:mouseleave"
                placement="bottom" container="body" popoverClass="loan-status-blurb-popover">{{ getLocalizedStatus(app) }}</td>
              <td>
                <span>{{ app.address || t('portal.loans.noStreetAddress') }}</span>
                <br />
                @if (app.city || app.state || app.zip) {
                  <span>{{ app.city ? app.city + "," : "" }} {{ app.state }}
                    {{ app.zip }}</span>
                }
              </td>
              <td>
                <person-circle-image class="app-contact" (click)="openAgentContact(app.applicationId)" [url]="
                    'https://core-api.lodasoft.dev/avatars/657a823f-89f7-4c3e-95e1-35799ca7f70e'
                  " [size]="30"></person-circle-image>

                <span class="ms-2">{{ app.contactName }}</span>
              </td>
              <td class="text-end">
                @if (app.onlineAppInProgress) {
                  <button type="button" class="btn btn-sm bp-orange-bg-color"
                   >
                    {{ t('portal.loans.complete') }}
                  </button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="d-block d-sm-none">
      <ng-template [ngTemplateOutlet]="loanCardView"></ng-template>
    </div>
  </div>
}
</ng-container>
